import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["startingTime", "endingTime", "lang", "timeZone", "expanded", "children", "showEndDate", "showStartTime", "showEndTime"];
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { formatDateWithTimeZone } from '../../utils';
import { Tag } from '../Typography';
const calculateDate = _ref => {
  let {
    startDate,
    startTime,
    endDate,
    endTime,
    showStartTime,
    showEndDate,
    showEndTime
  } = _ref;
  return React.createElement(React.Fragment, null, startDate, " ", showStartTime ? " | ".concat(startTime) : '', " ", showEndDate || showEndTime ? ' - ' : '', showEndDate ? "".concat(endDate) : '', " ", showEndDate && showEndTime ? ' | ' : '', showEndTime ? endTime : '');
};
export const FormattedDate = React.memo(function FormattedDate(_ref2) {
  let {
      startingTime,
      endingTime,
      lang,
      timeZone,
      expanded,
      children,
      showEndDate,
      showStartTime,
      showEndTime
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  const time = useMemo(() => {
    const [startDate, startTime] = formatDateWithTimeZone(startingTime, "".concat(expanded ? 'dddd, D MMMM YYYY' : 'ddd, DD MMM YYYY', "_HH:mm"), {
      lang,
      timeZone
    }).split('_');
    const [endDate, endTime] = formatDateWithTimeZone(endingTime, "".concat(expanded ? 'dddd, D MMMM YYYY' : 'ddd, DD MMM YYYY', "_HH:mm"), {
      lang,
      timeZone
    }).split('_');
    return {
      startDate,
      startTime,
      endDate,
      endTime
    };
  }, [startingTime, endingTime, lang, timeZone]);
  return children ? children(time) : React.createElement(Tag, props, calculateDate({
    startDate: time.startDate,
    startTime: time.startTime,
    endDate: time.endDate,
    endTime: time.endTime,
    showStartTime,
    showEndDate,
    showEndTime
  }));
});
FormattedDate.propTypes = process.env.NODE_ENV !== "production" ? {
  startingTime: PropTypes.number.isRequired,
  endingTime: PropTypes.number.isRequired,
  lang: PropTypes.string,
  timeZone: PropTypes.string,
  expanded: PropTypes.bool,
  children: PropTypes.func,
  showEndDate: PropTypes.bool,
  showStartTime: PropTypes.bool,
  showEndTime: PropTypes.bool
} : {};
FormattedDate.defaultProps = {
  lang: 'en',
  timeZone: 'Europe/Madrid',
  expanded: false,
  children: null,
  showEndDate: false,
  showStartTime: true,
  showEndTime: true
};